import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/es5/locale/de';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    light: true,
    themes: {
      light: {
        primary: '#0085CF',
        secondary: '#002C76',
        accent: '#0085CF',
        error: '#EF5350',
        info: '#002C76',
        success: '#3DB482',
        warning: '#F57F17'
      }
    }
  },
  lang: {
    locales: { de },
    current: 'de'
  }
});
